import { jsxs as _jsxs } from "react/jsx-runtime";
import s from '../../HoteliersProposeCard.module.scss';
export const Price = ({ price }) => {
    return _jsxs("h2", Object.assign({ className: s.card__price }, { children: [price, " USD"] }));
};
